import React from 'react';
import { IStyleProps, LottieAnimation } from '../LottieAnimation';
import whiskLoader from './whiskLoader.json';

export const LottieWhiskLoader: React.FC<IStyleProps> = (props) => (
  // The whisk canvas is portrait (300x365); centre it in the square slots Loading renders it
  // into, instead of the wrapper's left-anchoring default.
  <LottieAnimation animationData={whiskLoader} preserveAspectRatio='xMidYMid meet' {...props} />
);
